import { request } from './request.js'

export const getProducts = params => request.get('products', { params })
export const getProductsById = id => request.get('products/' + id)
export const getRecommendedProducts = () => request.get('recommended-products')
export const getProductsByKeyword = params => request.get('products/search', { params })
export const getProductsByNumber = number => request.get(`products/number-search/${number}`)
